import {
  // Avatar,
  Divider,
  // IconButton,
  Menu,
  type MenuProps,
} from '@affine/component';
import {
  type AuthAccountInfo,
  AuthService,
  ServerService,
  SubscriptionService,
  UserCopilotQuotaService,
} from '@affine/core/modules/cloud';
import {
  GlobalDialogService,
  WorkspaceDialogService,
} from '@affine/core/modules/dialogs';
import { useI18n } from '@affine/i18n';
import {
  Fallback as AvatarFallback,
  Image as AvatarImage,
  Root as AvatarRoot,
} from '@radix-ui/react-avatar';
import { t, useLiveData, useService } from '@toeverything/infra';
import IconFont from '@ys/repo-ui/base/IconFont';
import { useCallback, useEffect, useMemo, useState } from 'react';

// import { Account } from './account';
import { AccountMenu } from './account-menu';
import { AIUsage } from './ai-usage';
import { CloudUsage } from './cloud-usage';
import * as styles from './index.css';
import { TeamList } from './team-list';
import { style } from '@vanilla-extract/css';
import { AppSidebarService } from '@affine/core/modules/app-sidebar';
import { SubscriptionPlan } from '@affine/graphql';
import { UserCreditsDetailsService } from '@affine/core/modules/cloud/services/user-credits-detail';
import { useHoverSupport } from '../../hooks/use-hover-support';
// import { TeamList } from './team-list';
// import { UnknownUserIcon } from './unknow-user';
interface UserInfoProps {
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export default function UserInfo({
  onMouseEnter,
  onMouseLeave,
}: UserInfoProps) {
  const session = useService(AuthService).session;
  const account = useLiveData(session.account$);
  return account ? (
    <AuthorizedUserInfo
      account={account}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  ) : (
    <UnauthorizedUserInfo />
  );
}

const menuContentOptions: MenuProps['contentOptions'] = {
  className: styles.operationMenu,
};
const AuthorizedUserInfo = ({
  account,
  onMouseEnter,
  onMouseLeave,
}: {
  account: AuthAccountInfo;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}) => {
  const subscriptionService = useService(SubscriptionService);
  const workspaceDialogService = useService(WorkspaceDialogService);
  const creditsDetail = useService(UserCreditsDetailsService).creditsDetail;
  const credits = useLiveData(creditsDetail.credits$);
  const supportsHover = useHoverSupport();

  const t = useI18n();

  useEffect(() => {
    // 立即请求一次
    creditsDetail.revalidate();

    // 设置定时器，每5分钟重新请求一次
    const interval = setInterval(() => {
      creditsDetail.revalidate();
    }, 300000); // 5分钟

    // 清理定时器
    return () => clearInterval(interval);
  }, [creditsDetail]);

  useEffect(() => {
    // revalidate subscription to get the latest status
    subscriptionService.subscription.revalidate();
  }, [subscriptionService]);

  const plan = useLiveData(subscriptionService.subscription.currentPlan$);

  const onClickUpgrade = useCallback(() => {
    workspaceDialogService.open('setting', {
      activeTab: 'plans',
    });
  }, [workspaceDialogService]);
  // const planLabel = useMemo(() => {
  //   if (plan) {
  //     return plan;
  //   } else if (
  //     copilotActionLimit &&
  //     copilotActionUsed !== null &&
  //     copilotActionLimit !== 'unlimited'
  //   ) {
  //     return t['com.affine.user.free.left.times']({
  //       left: (copilotActionLimit - copilotActionUsed).toString(),
  //     });
  //   } else {
  //     return 'Free';
  //   }
  // }, [plan, copilotActionLimit, copilotActionUsed, t]);
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);
  const smallScreenMode = useLiveData(appSidebarService.smallScreenMode$);
  const hovering = useLiveData(appSidebarService.hovering$) && open !== true;

  const sidebarState = smallScreenMode
    ? open
      ? 'floating-with-mask'
      : 'close'
    : open
      ? 'open'
      : hovering
        ? 'floating'
        : 'close';
  return (
    <>
      {/* <div
        className={styles.userInfoUpgrade}
        onClick={supportsHover ? onClickUpgrade : undefined}
        onMouseEnter={() => {
          onMouseEnter?.();
        }}
        onMouseLeave={() => {
          onMouseLeave?.();
        }}
      >
        <div className={styles.userInfoUpgradeLeft}>
          <img
            className={styles.userInfoUpgradeImage}
            src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/upGradeIcon.png"
          />
          <div className={styles.userInfoUpgradeContent}>
            <div className={styles.userInfoUpgradeTitle}>
              {plan === SubscriptionPlan.Studio
                ? t['com.affine.user.free.upgrade.title-studio']()
                : t['com.affine.user.free.upgrade.title']()}
            </div>
            <div className={styles.userInfoUpgradeLeftTimes}>
              {t['com.affine.user.free.left.times']()}
              {credits.effective}
            </div>
          </div>
        </div>

        <div>
          <IconFont
            className={styles.userInfoUpgradeRight}
            name="leftArrow"
            size="24"
          />
        </div>
      </div> */}

      {/* <IconButton
        data-testid="sidebar-user-avatar"
        variant="plain"
        size="20"
        style={{ padding: 0 }}
        withoutHover
      >
        <Avatar size={20} name={account.label} url={account.avatar} />
      </IconButton> */}

      <div
        className={styles.userInfo}
        data-sidebar-is-floating={
          sidebarState === 'floating' || sidebarState === 'floating-with-mask'
        }
      >
        <Menu items={<OperationMenu />} contentOptions={menuContentOptions}>
          <div className={styles.userInfoLeft}>
            <AvatarRoot>
              <AvatarImage
                className={styles.userInfoAvatarImage}
                src={account.avatar || ''}
              />
              <AvatarFallback>
                <img
                  src="https://static.chatxbai.com/avatar/default/default-head.jpeg"
                  alt="avatar"
                  className={styles.userInfoAvatarImage}
                />
              </AvatarFallback>
            </AvatarRoot>
            <div className={styles.userInfoRight}>
              <div className={styles.userInfoName}>{account.label}</div>
            </div>
          </div>
        </Menu>
        {plan !== SubscriptionPlan.Free && (
          <div
            data-plan-button
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              workspaceDialogService.open('setting', {
                activeTab: 'plans',
              });
            }}
            className={`${styles.userInfoPricePro}`}
          >
            {plan}
          </div>
        )}
      </div>
    </>
  );
};

const UnauthorizedUserInfo = () => {
  const globalDialogService = useService(GlobalDialogService);
  const t = useI18n();
  const openSignInModal = useCallback(() => {
    globalDialogService.open('sign-in', {});
  }, [globalDialogService]);

  return (
    <div className={styles.unauthorizedUserInfo} onClick={openSignInModal}>
      <IconFont className={styles.unknownUserIcon} name="user" size="24" />

      <span className={styles.unauthorizedUserText}>
        {t['com.affine.ai.login-required.dialog-confirm']()}
      </span>
    </div>
  );
};

const OperationMenu = () => {
  // const serverService = useService(ServerService);
  // const serverFeatures = useLiveData(serverService.server.features$);

  return (
    <>
      {/* <Account /> */}
      {/* <Divider />
      <CloudUsage />
      {serverFeatures?.copilot ? <AIUsage /> : null}
      <Divider /> */}
      {/* <TeamList /> */}
      <AccountMenu />
    </>
  );
};
